/*
 * Presentación de los cuatro estados de un listado (RF-087, D-83).
 *
 * Son piezas tontas: reciben el estado ya resuelto por `useConsultaDeListado` y lo
 * pintan. La decisión de CUÁL estado corresponde no se toma aquí, para que se
 * pueda afirmar en prueba una regla por número.
 */

import AvisoDeError from '../avisos/AvisoDeError.jsx';

/**
 * Esqueleto de carga (RN-140a). Ocupa el lugar de la lista para que la pantalla no
 * salte cuando lleguen los datos, y NO afirma nada sobre si hay registros.
 */
export function ListadoCargando({ renglones = 3, texto = 'Cargando…' }) {
  return (
    <div className="card" style={{ margin: 12 }} aria-busy="true" data-prueba="listado-cargando">
      <span className="ayuda">{texto}</span>
      {Array.from({ length: renglones }, (_, indice) => (
        <div className="fila" key={indice} aria-hidden="true">
          <div className="crece">
            <div style={{ height: 12, width: '55%', borderRadius: 6, background: 'var(--bor)' }} />
            <div style={{ height: 9, width: '35%', borderRadius: 6, background: 'var(--bor)', marginTop: 6, opacity: 0.6 }} />
          </div>
          <div style={{ height: 12, width: 72, borderRadius: 6, background: 'var(--bor)' }} />
        </div>
      ))}
    </div>
  );
}

/**
 * Error de consulta (RN-140d, RN-141). SIEMPRE trae Reintentar: un fallo de red no
 * es un hogar sin cuentas.
 *
 * Desde el incremento 08 usa el AVISO ÚNICO del núcleo (RF-139, RN-354): mismo
 * recuadro, mismo orden —mensaje, detalles, código atenuado al final— que en los
 * formularios. El error de carga sigue presentándose dentro del estado del
 * listado, con su opción de reintentar, que es la regla vigente.
 *
 * El texto ya no se resuelve aquí: lo garantiza el cliente de API, que nunca deja
 * llegar un error sin mensaje a la vista (RF-140).
 */
export function ListadoConError({ error, alReintentar }) {
  return (
    <AvisoDeError
      error={error}
      datoDePrueba="listado-error"
      acciones={(
        <button className="btn sec" type="button" onClick={alReintentar} data-prueba="listado-reintentar">
          Reintentar
        </button>
      )}
    />
  );
}

/**
 * Barra de actualización (RN-142a, RNF-042). Aparece SOBRE la lista ya visible: la
 * lista no se vacía mientras llega la respuesta nueva.
 */
export function ListadoActualizando({ visible }) {
  if (!visible) return null;
  return (
    <div className="ayuda" role="status" style={{ margin: '10px 12px 0' }} data-prueba="listado-actualizando">
      Actualizando…
    </div>
  );
}
